var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLing0)",
    fillRule: "evenodd",
    d: "M7.44 6.857c-.938 0-1.577.994-1.577 1.851c0 .223.043.429.095.588c-.729 1.795-1.672 3.882-1.672 5.85c0 .9.489 1.997 1.53 1.997c1.457 0 2.872-1.963 3.63-3c.827.171 1.714.441 2.554.428c.845.013 1.728-.257 2.555-.428c.724.985 2.164 3 3.63 3c1.041 0 1.53-1.098 1.53-1.998c0-1.97-.943-4.054-1.672-5.85a2 2 0 0 0 .095-.587c0-.857-.643-1.851-1.578-1.851c-.552 0-.878.15-1.307.351l-.145.065c-.995-.159-2.036-.416-3.108-.416c-1.071 0-2.112.257-3.107.416l-.145-.065c-.429-.201-.755-.351-1.308-.351M12 8.143c-1.071 0-2.07.094-3.055.308a.55.55 0 0 1-.343-.034l-.399-.171c-.381-.176-.471-.22-.763-.22c-.274 0-.428.472-.428.687c0 .097.02.194.06.283a.59.59 0 0 1 .034.527c-.728 1.77-1.534 3.677-1.534 5.623c0 .214.064.71.386.71c1.037-.016 2.288-2.056 2.785-2.76a.56.56 0 0 1 .596-.226c.763.184 1.989.403 2.661.416c.673-.013 1.899-.232 2.662-.416a.57.57 0 0 1 .6.227c.626.9 1.487 2.734 2.786 2.76c.317 0 .381-.493.381-.711c0-1.946-.806-3.858-1.534-5.623a.59.59 0 0 1 .034-.527a.7.7 0 0 0 .064-.288c0-.21-.158-.681-.428-.681c-.296 0-.386.043-.772.214l-.39.176a.56.56 0 0 1-.343.034A14.3 14.3 0 0 0 12 8.143",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9410ED",
    d: "M9.429 9.857a.429.429 0 0 0-.857 0v1.714a.429.429 0 1 0 .857 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9410ED",
    d: "M9.858 11.143a.428.428 0 1 0 0-.857H8.143a.429.429 0 0 0 0 .857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7024E7",
    d: "M14.786 11.571a1.071 1.071 0 1 0 0-2.143a1.071 1.071 0 0 0 0 2.143"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLing0",
    x1: 12,
    x2: 12,
    y1: 6.857,
    y2: 17.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B202FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3741D7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLing);
export default __webpack_public_path__ + "static/media/ling.46ecdbeb8b7829acc481ac0fabd3b367.svg";
export { ForwardRef as ReactComponent };